import { Clock, User } from 'lucide-react';
import { cn } from '@/lib/utils';
import { mapStatus } from '@/lib/clientStatus';
import { StatusBadge } from '@/components/ui/StatusBadge';
import { addRecentClient } from '@/lib/recentClients';
import type { AccountSearch } from '@/models/clients/types';

interface Props {
  recents: AccountSearch[];
  hasSearch: boolean;
  onClientClick: (client: AccountSearch) => void;
}

export function ClientsRecentList({ recents, hasSearch, onClientClick }: Props) {
  return (
    <div
      className={cn(
        'w-full overflow-hidden transition-[max-height,opacity,margin] duration-380 ease-out',
        !hasSearch && recents.length > 0
          ? 'max-h-80 opacity-100 mt-5 max-w-lg'
          : 'max-h-0 opacity-0 mt-0 max-w-lg'
      )}
    >
      <div className='flex items-center gap-2 mb-2 text-xs font-medium text-muted-foreground uppercase tracking-wider'>
        <Clock className='w-3.5 h-3.5' />
        Недавние
      </div>
      <div className='border border-border/30 rounded-2xl bg-card overflow-hidden'>
        {recents.map((client, i) => {
          const status = mapStatus(client.status_name);
          return (
            <a
              key={client.id_account}
              href={`/clients/${client.id_account}`}
              onClick={(e) => {
                if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button === 0) {
                  e.preventDefault();
                  onClientClick(client);
                } else {
                  addRecentClient(client);
                }
              }}
              className={cn(
                'flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-muted/30 transition-colors',
                i !== recents.length - 1 && 'border-b border-border/20'
              )}
            >
              <div className='flex items-center gap-3 min-w-0'>
                <div className='w-8 h-8 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center shrink-0'>
                  <User className='w-4 h-4 text-primary' />
                </div>
                <div className='min-w-0'>
                  <p className='text-sm font-medium text-foreground truncate'>
                    {client.account_name}
                  </p>
                  <p className='text-xs font-mono text-muted-foreground'>{client.login}</p>
                </div>
              </div>
              <span className='ml-3 shrink-0'>
                <StatusBadge status={status} label={client.status_name} size='sm' />
              </span>
            </a>
          );
        })}
      </div>
    </div>
  );
}
